// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"P_c8","categories__list":"P_c9"};